import { render, staticRenderFns } from "./integration-service-details.vue?vue&type=template&id=7415c084&scoped=true"
import script from "./integration-service-details.vue?vue&type=script&lang=js"
export * from "./integration-service-details.vue?vue&type=script&lang=js"
import style0 from "./integration-service-details.vue?vue&type=style&index=0&id=7415c084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7415c084",
  null
  
)

export default component.exports